import {NgModule} from '@angular/core';
import {StoreModule} from '@ngrx/store';
import {metaReducers, reducers} from './store.index';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {EffectsModule} from '@ngrx/effects';
import {OrdersStoreModule} from './orders/orders.store.module';
import {PositionStoreModule} from './positions/position.store.module';
import {DeliveriesStoreModule} from './deliveries/deliveries.store.module';
import {IncidentsStoreModule} from './incidents/incidents.store.module';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {metaReducers}),
    StoreDevtoolsModule.instrument(),
    EffectsModule.forRoot([]),
    IncidentsStoreModule,
    OrdersStoreModule,
    PositionStoreModule,
    DeliveriesStoreModule
  ]
})
export class ProleisSuppliersStoreModule {

}
